import { render, staticRenderFns } from "./SoapMetrics.vue?vue&type=template&id=0f9f2cec&"
import script from "./SoapMetrics.vue?vue&type=script&lang=js&"
export * from "./SoapMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports